import React, { useCallback, useEffect, useState } from "react";
import * as services from "../../../../services/product.services";
import { serverResponse } from "../../../../util/fakeServer";
import { connect } from "react-redux";
import ManagerFactory from "../../../../managers/ManagerFactory";
import {
  getItemVatLabels,
  isVatExcludedFlyer,
  getCounterpartPriceLabel,
} from "../../../../helper/vat";

const manager = ManagerFactory.getManager();

const Price = ({
  strike_price,
  price,
  offer_price,
  discount_rate,
  price_label,
  no_price,
  fontSize = "1rem",
  styleContainer = {},
  styleParagraph = "unset",
  customClass = true,
  skul,
  dynamic_price,
  dynamic_info,
  price_for_kg,
  left = "unset",
  top = "unset",
  getPrice = true,
  priceReducer,
  item_id,
  iva,
  priceType,
  vatLabelFontSize = "0.7rem",
}) => {
  const formattedPrice = (el, symbol = "") =>
    `${symbol}${parseFloat(el).toFixed(2).toString().replace(".", ",")}`;

  const [serverPrice, setServerPrice] = useState(null);
  const [loadingPrice, setLoadingPrice] = useState(
    dynamic_price && !dynamic_info && getPrice
  );

  const getPriceForItem = useCallback(async () => {
    try {
      const {
        data: { data: res },
      } = await services.getPrices([skul], serverResponse.config.id_listino);

      if (res) {
        setServerPrice(res[0][skul]);
        setLoadingPrice(false);
      }
    } catch (error) {
      console.log(error);
    }
  }, [skul]);

  useEffect(() => {
    if (dynamic_price && !dynamic_info && getPrice) {
      getPriceForItem();
    }
  }, [dynamic_price, dynamic_info, getPrice, getPriceForItem]);

  const classes = "priceinner";
  const symbol = "€ ";

  if (no_price) return null;

  if (
    (loadingPrice || priceReducer.isLoading) &&
    !(skul in priceReducer.productPrices) &&
    dynamic_price
  ) {
    return (
      <div
        className="spinner-grow "
        style={{
          width: "5rem",
          height: "5rem",
          color: serverResponse.config.secondary_color,
        }}
        role="status"
      />
    );
  }

  const symbolEuro = (str) => (
    <>
      {str && !str.includes(symbol) && (
        <span
          className="currency"
          style={{
            fontWeight: "700",
            color: "#0d0040",
          }}
        >
          €{" "}
        </span>
      )}
      {str && str.toString().replace(/(\d+)\.(\d+)/g, "$1,$2")}
    </>
  );

  const hasEuroChar = price_label.indexOf("€") === 0;

  const priceLabel = () => {
    if (dynamic_price && !dynamic_info) return symbolEuro(serverPrice);

    if (serverResponse.config.client_id === 3531) {
      let priceToReturn = price_label
        .toString()
        .replace(/(\d+)\.(\d+)/g, "$1,$2");
      if (hasEuroChar)
        return priceToReturn.replace("€", " ") + (hasEuroChar ? " €" : "");
      else return priceToReturn;
    }

    if (hasEuroChar)
      return symbolEuro(
        price_label.replace(/(\d+)\.(\d+)/g, "$1,$2").replace("€", "")
      );

    return price_label.replace(/(\d+)\.(\d+)/g, "$1,$2");
  };

  // Diciture IVA della riga: "IVA Esclusa" e, con il flag show_vat_percentage,
  // l'aliquota del prodotto. Sono per prodotto (un volantino puo' mescolare
  // prezzi netti e ivati); sui volantini senza `priceType` nei dati si ricade
  // sull'etichetta di manager, che alcuni client (Rud) impostano a mano.
  const vatLabels = (() => {
    const labels = getItemVatLabels({ item_id, iva, priceType, no_price });
    if (labels.length > 0) return labels;
    if (!isVatExcludedFlyer() && !no_price && manager.getIvaLabel())
      return [manager.getIvaLabel()];
    return [];
  })();

  const getPriceLabel = (
    <>
      <span
        className="product-price-block"
        style={{
          display: "inline-flex",
          flexDirection: "column",
        }}
      >
        <span
          className="price_span"
          style={{
            fontFamily: "Rubik",
            color: "#0D0040",
          }}
        >
          {priceLabel()}
        </span>
      </span>
    </>
  );

  // show_price_with_and_without_vat: prezzo esposto nell'altro regime IVA.
  // Si calcola sull'importo che finisce davvero a video, quindi sul prezzo
  // dinamico quando e' quello a essere mostrato.
  const shownAmount =
    dynamic_price && !dynamic_info
      ? serverPrice
      : dynamic_price
      ? priceReducer.productPrices[skul]
      : price_label;
  const counterpartLabel = getCounterpartPriceLabel(
    { item_id, iva, priceType, no_price },
    shownAmount
  );

  // Le diciture IVA stanno SEMPRE in coda al blocco prezzo, sotto l'eventuale
  // prezzo al kg/litro. Non possono vivere dentro <p class="priceinner">:
  // quel contenitore e' flex column-reverse (categorystatic.css) e le
  // ribalterebbe sopra il prezzo.
  const getVatLabels = vatLabels.length > 0 && (
    <span
      className="product-vat-labels"
      style={{
        display: "block",
        fontSize: vatLabelFontSize,
        lineHeight: "1.2",
        fontWeight: "600",
        // Stesso colore del prezzo, leggermente opacizzato: l'etichetta
        // resta secondaria senza staccarsi dal blocco prezzo.
        color: "#0D0040",
        opacity: 0.7,
        fontFamily: "var(--font-family)",
      }}
    >
      {vatLabels.map((label, i) => (
        <React.Fragment key={i}>
          {i > 0 && " \u00B7 "}
          {label}
        </React.Fragment>
      ))}
    </span>
  );

  return (
    <>
      {!!(!getPrice && dynamic_price) && (
        <>
          <p
            className="price_span mt-3"
            style={{
              fontSize: fontSize,
              lineHeight: "2rem",
              fontWeight: "900",
              color: serverResponse.config.primary_color,
              whiteSpace: "nowrap",
            }}
          >
            {symbolEuro(priceReducer.productPrices[skul])}
          </p>
        </>
      )}
      { 
        // <div className={`product-price`} style={styleContainer}>
        <>
          {offer_price && (
            <>
              <p className="barrato offerPrice">
                {dynamic_price && !dynamic_info ? serverPrice : `€ ${price}`}
              </p>
              <p
                className={`${customClass ? classes : ""}`}
                style={{ fontWeight: "bold", paddingRight: styleParagraph }}
              >
                {discount_rate !== undefined &&
                  parseFloat(discount_rate) !== 0 &&
                  discount_rate !== null && (
                    <span className="discount-rate">{discount_rate}%</span>
                  )}
                {getPriceLabel}
              </p>
            </>
          )}
          {!offer_price && (
            <div className="product-price-block">
              <div className="priceBlock">
                {getPriceLabel}
                {discount_rate !== undefined &&
                  parseFloat(discount_rate) !== 0 &&
                  discount_rate !== null && (
                    <span className="discount-rate">{discount_rate}%</span>
                  )}
              </div>
            </div>
          )}
          {price_for_kg && (
            <p className="priceKg">{price_for_kg}</p>
          )}
          {getVatLabels}
          {counterpartLabel && (
            <span
              className="product-vat-counterpart"
              style={{
                display: "block",
                fontSize: vatLabelFontSize,
                lineHeight: "1.2",
                fontWeight: "600",
                color: "#0D0040",
                opacity: 0.55,
                fontFamily: "var(--font-family)",
              }}
            >
              {counterpartLabel}
            </span>
          )}
        </>
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    priceReducer: state.priceReducer,
  };
};
export default connect(mapStateToProps, null)(Price);
